import React from 'react';
import PropTypes from 'prop-types';
import { Fields, SingleSelect, TypedInput, Types } from 'smartsuite-ui';
import { timeAndPrecisionConfigurationKeys } from '../constants/constants';
import { useLabelContext } from '../hooks/labelContext';

// eslint-disable-next-line complexity
export default function PrecisionSelector({
    disabled,
    isGauge,
    precisionTypeOptions,
    saveTimeAndPrecision,
    showPrecisionConfig,
    timeAndPrecision,
}) {
    const { dashboardLabels, translationLabels } = useLabelContext();
    const formattedPrecisionTypeOptions = precisionTypeOptions.map((type) => ({
        textField: dashboardLabels[type],
        valueField: type,
    }));

    function handlePrecisionTypeChange(event) {
        saveTimeAndPrecision({
            ...timeAndPrecision,
            [timeAndPrecisionConfigurationKeys.precisionType]: event.valueField,
        });
    }

    function handlePrecisionValueChange(value) {
        saveTimeAndPrecision({
            ...timeAndPrecision,
            [timeAndPrecisionConfigurationKeys.precisionValue]: value,
        });
    }

    if (!showPrecisionConfig || isGauge) {
        return null;
    }

    return (
        <Fields cssClassModifiers={['no-background', 'no-pad-top-bottom']}>
            <TypedInput
                disabled={disabled}
                label={translationLabels.every}
                value={timeAndPrecision.precisionValue || ''}
                onChange={handlePrecisionValueChange}
                placeholder={dashboardLabels.precisionPlaceholder}
                type={Types.Int32Positive}
            />
            <SingleSelect
                disabled={disabled}
                isClearable={false}
                isValid={!!timeAndPrecision.precisionType}
                onChange={handlePrecisionTypeChange}
                options={formattedPrecisionTypeOptions}
                textField="textField"
                valueField="valueField"
                value={
                    formattedPrecisionTypeOptions.find(
                        (x) => x.valueField === timeAndPrecision.precisionType
                    ) ?? ''
                }
            />
        </Fields>
    );
}

PrecisionSelector.propTypes = {
    disabled: PropTypes.bool,
    isGauge: PropTypes.bool.isRequired,
    precisionTypeOptions: PropTypes.instanceOf(Array).isRequired,
    saveTimeAndPrecision: PropTypes.func.isRequired,
    timeAndPrecision: PropTypes.instanceOf(Object).isRequired,
    showPrecisionConfig: PropTypes.bool,
};

PrecisionSelector.defaultProps = {
    disabled: false,
    showPrecisionConfig: true,
};
